import { Component, OnInit, Input } from '@angular/core';
import { ColumnChartConfig } from '../../../../../shared/google-chart/Models/ColumnChartConfig';
import { ChartUtil } from '../../../../../shared/services/utility/chart.service';
import { TranslateService } from '@ngx-translate/core';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import * as moment from 'moment';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';


@Component({
  selector: 'app-plc-activity-new',
  templateUrl: './plc-activity-new.component.html',
  styleUrls: ['./plc-activity-new.component.css']
})
export class PlcActivityNewComponent implements OnInit {
	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	@Input() siteBattviewsData: any = {};
	@Input() siteTags: any = {};
	@Input() siteBattviewsTags: any = {};
	@Input() customerName: string = '';
	@Input() siteName: string = '';
	@Input() isACTuser: boolean = false;

	config: ColumnChartConfig;
	filteredData: any;
	tableColumns: any[];
	title: string;
	elementId: string = 'plc_activity_new';
	widgetClass: string = 'auto-height-widget';
	chartData: any = { list: [], summary: {} };
	siteWidgetOptions: any = {
		hasOperation: false,
		hasChargerModels: false,
		hasDate: true,
		hasDateRange: false,
		hideYesterdayDate: true,
		excludeSinceInstallationOption: true,
		isSitePerformanceWidget: true,
		isChargers: true,
		showWidgetSummary: false,
	};

	constructor(
		private chartUtil: ChartUtil,
		private translateService: TranslateService,
		private commonUtil: CommonUtil
	) {
		this.title = this.translateService.instant('charger.plc_activity');
		this.tableColumns = [
			{title: this.translateService.instant('device.charger_id'), property: "chargerusername"},
			{title: this.translateService.instant('charger.charger_sn'), property: "serialnumber"},
			{title: "% "+this.translateService.instant('charger.plc'), property: "value"}
		];
	}

	ngOnInit() {
		console.log('PLC Activity Component Init');
		this.initializeConfig();
	}

	private initializeConfig() {
		this.config = new ColumnChartConfig({
			xTitle: "% " + this.translateService.instant('charger.plc'),
			yTitle: this.translateService.instant("g.chargers"),
			vAxisMinValue: 0,
			chartArea: {top: 20, width: '85%', height: '75%'},
			legend: { position: 'none' },
			tooltip: { trigger: 'both' },
			bar: { groupWidth: '85%' }
		});

		this.config.formatFunction = (data) => {
			if(data.summary)
				return {list: data.summary.value};

			data = data.list;

			if(!data) return {list: 0};

			let totalValue = 0;
			let dependency = 550;  //(10% * 100%) + (20% * 100%) + (30% * 100%) + ... + (90% * 100%) + (100% * 100%) = 550%
		 
			for(let i = 0; i < data.length; i++) {
			 let item: any = data[i];
		 
			 totalValue += item.x * item.y;   //accumulated value(Y %charger with X %PLC) = PLC at item.X% * charger amount at item.Y%
			}
		
			return {list: (totalValue / dependency).toFixed(2)}   //total weighted / ideal full weight value (550% PLC with 100% charger being used)
		};
	}

	eventEmit(event: {type: string, data: any}) {
		switch (event.type) {
			case "export":
				let exportFilters = this.commonUtil.getExportWidgetFiltersInfo(event.data);
				let csvData: any = [{
					a: 'Site: '+this.customerName+'/'+this.siteName
				}];
				for(let key in exportFilters) {
					csvData.push({a: exportFilters[key]});
				}
				csvData.push({a: 'Date of print: '+ moment().format('LL')}, {}); // Date of print & an empty row
				csvData.push({a: "Charger Id", b: "Charger SN", c: "Value", d: "Charger User Name"});
				for(let range in this.filteredData) {
					let devices = this.filteredData[range].list;

					if(devices){
						devices.forEach((device: any) => {
							csvData.push({a: device.chargerid, b: device.serialnumber, c: device.value, d: device.chargerusername});


						});
					}

				}
				let fileName = `${this.title} - ${this.customerName} / ${this.siteName}`;
				new ngxCsv(csvData, fileName);
				break;

			case "filteredData":
				this.filteredData = event.data;
				break;

			case 'periodChange':
				this.siteWidgetOptions.selectedPeriod = event.data;
				break;
		}
	}

	// onDropDownChange method removed
}
